import React from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Search } from 'lucide-react';
import { SearchBarProps } from '../types';

const SearchBar: React.FC<SearchBarProps> = ({
  searchText,
  onSearchChange,
  onSearch,
  loading = false,
  placeholder = "Buscar usuario...",
}) => {
  const handleKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      onSearch();
    }
  };

  return (
    <div className="flex min-w-0 flex-1 items-center gap-2">
      <Input 
        placeholder={placeholder}
        value={searchText}
        onChange={(e) => onSearchChange(e.target.value)}
        onKeyPress={handleKeyPress}
        className="min-w-0 sm:min-w-[200px]"
      />
      <Button 
        onClick={onSearch} 
        disabled={loading}
        size="sm"
        className="px-4 shrink-0"
      >
        <Search className="h-4 w-4 mr-1" />
        Buscar
      </Button>
    </div>
  );
};

export default SearchBar;